module.exports = __webpack_public_path__ + "img/TradingView-icon9.abe82d81.svg";